import { type FC } from "react";

import { ArrowRight } from "lucide-react";

import { Button } from "@/shared/components/ui/button";
import { cn } from "@/shared/utils/core";

import introIllustration from "@/shared/assets/illustrations/legal-authority-intro.svg";

interface LegalAuthorityIntroStepProps {
  personFirstName: string;
  className?: string;
  onContinue: () => void;
}

export const LegalAuthorityIntroStep: FC<LegalAuthorityIntroStepProps> = ({
  personFirstName,
  className,
  onContinue,
}) => {
  const personName = personFirstName || "your loved one";

  return (
    <div className={cn("flex h-full items-center p-2", className)}>
      <div className="flex h-full flex-1 flex-row items-center gap-6">
        <div className="flex flex-1 flex-col items-start gap-6 p-4">
          <div className="flex w-full flex-col gap-2">
            <h4>Let's find your path to legal authority</h4>
            <p className="text-sm text-secondary">
              Legal authority lets you access {personName}'s finances, sell or transfer property,
              and open an estate bank account.
            </p>
            <p className="text-sm text-secondary">
              Your answers here help us determine your path to authority: probate, a simple court
              process, or no court at all.
            </p>
          </div>
          <Button variant="brand" className="w-full rounded-full" onClick={onContinue}>
            Continue
            <ArrowRight className="h-4 w-4" />
          </Button>
        </div>
        <div className="hidden flex-1 self-stretch items-center justify-center overflow-hidden rounded-lg bg-background sm:flex">
          <img
            src={introIllustration}
            alt="Legal authority documents illustration"
            className="h-[300px] w-[300px]"
          />
        </div>
      </div>
    </div>
  );
};
